<template>
  <div v-if="isLoading" class="spinner-container big">
    <div class="spinner"></div>
  </div>
  <productsCollection v-else-if="!selectedProduct"/>
  <productModal v-else :curatedBox="selectedProduct" />
</template>

<script>
import { mapGetters } from 'vuex';
import productsCollection from './components/products-collections.vue'
import productModal from './components/product-modal.vue'

export default {
  components:{
    productsCollection,
    productModal
  },
  directives: {
  },
  data(){
    return{
    }
  },
  computed:{
    ...mapGetters([
      'selectedProduct',
      'isLoading'
    ]),
  },
  methods:{
  },
  mounted() {
  },
  destroy() {
  }
}
</script>

<style>

.global-spinner-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.2);
  position: fixed;
  height: 100%;
  z-index: 999;
  top: 0;
}

.global-spinner-container p{
  font-size: 16px;
  color: white !important;
  font-weight: bold;
}

.global-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
}
 
</style>